module.exports = __webpack_public_path__ + "static/media/iphone-bzr-demo.f8008acc.png";